<template>
  <div>
    <v-card width="100%" :height="widgetHeight">
      <v-img class="mainBgImage" :src="landingPicture" :height="widgetHeight">
        <div class="overlay" v-if="isDirty"></div>
        <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
          v-if="loadingPicture"
        >
          <v-progress-circular
            indeterminate
            color="black lighten-5"
          ></v-progress-circular>
        </v-row>
        <div
          v-else
          class="d-flex flex-column fill-height justify-end align-center text-white"
          style="width: 100%"
          :class="{ 'slider-container': isDirty }"
        >
          <div v-if="isDirty && $security.checkUserAccess('ViewAdmin')">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a-btn
                  v-bind="attrs"
                  v-on="on"
                  color="primaryDark"
                  @click="saveDisplayOrder"
                >
                  <v-icon size="16">mdi-content-save</v-icon>
                  {{ $t("btnSave") }}
                </a-btn>
              </template>
              <span>{{ $t("people.btnSaveOrder") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a-btn
                  v-bind="attrs"
                  v-on="on"
                  color="secondary"
                  class="ml-2"
                  @click="restoreOrder"
                  >{{ $t("btnCancel") }}</a-btn
                >
              </template>
              <span>{{ $t("btnCancel") }}</span>
            </v-tooltip>
          </div>
          <v-slide-group
            :key="render"
            class="pa-4 pt-10 pb-10"
            show-arrows
            prev-icon="mdi-chevron-left"
            next-icon="mdi-chevron-right"
            :dark="isDirty"
            v-if="slideGroupReady"
          >
            <v-slide-item
              v-show="$security.checkUserAccess('ViewDashboard') && false"
              class="widget-item"
            >
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-card
                    color="white"
                    class="ma-1 ml-5 elevation-14 rounded-xl"
                    :width="172"
                  >
                    <v-tooltip
                      bottom
                      v-show="$security.checkUserAccess('ViewDashboard')"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-card-text
                          v-bind="attrs"
                          v-on="on"
                          class="fill-height ma-0 pa-0 d-flex justify-center flex-column rounded-xl"
                          align="center"
                          justify="center"
                        >
                          <!-- <v-scale-transition> -->
                          <v-icon size="75" color="primary">
                            mdi-view-dashboard
                          </v-icon>
                          <span
                            style="
                              color: var(--v-primary-base);
                              font-family: Noto Sans JP;
                              font-style: normal;
                              font-weight: 700;
                              font-size: 16px;
                            "
                          >
                            {{ $t("menu.dashboard") }}</span
                          >
                          <!-- </v-scale-transition> -->
                          <v-fade-transition>
                            <v-overlay
                              v-if="hover"
                              absolute
                              color="#000000"
                              class="overlay-action-box"
                              style="cursor: pointer"
                              opacity="0.6"
                              @click.native="
                                $security.checkUserAccess('ViewDashboard')
                                  ? $router.push('/dashboard')
                                  : ''
                              "
                            >
                            </v-overlay>
                          </v-fade-transition>
                        </v-card-text>
                      </template>
                      <span>{{ $t("home.tipDashboardThumbnail") }}</span>
                    </v-tooltip>
                  </v-card>
                </template>
              </v-hover>
            </v-slide-item>
            <draggable
              v-model="documentListItems"
              v-if="documentListItems"
              handle=".drag-handle"
              class="draggable-row"
              @change="onChanged($event, documentListItems)"
            >
              <v-slide-item
                class="widget-item"
                v-for="item in documentListItems"
                :key="item.id"
                v-slot="{ active }"
              >
                <v-hover>
                  <template v-slot:default="{ hover }">
                    <v-card
                      :color="active ? undefined : 'white'"
                      class="ma-1 ml-5 rounded-xl"
                    >
                      <v-card-text
                        class="fill-height ma-0 pa-0 rounded-xl"
                        align="center"
                        justify="center"
                      >
                        <v-scale-transition>
                          <v-img
                            class="rounded-xl widget-img"
                            :src="`data:image/png;base64,${item.doc_thumbnail}`"
                            width="172"
                            :contain="isNotPDF(item)"
                            :aspect-ratio="16 / 9"
                          >
                          </v-img
                        ></v-scale-transition>
                        <v-fade-transition>
                          <v-overlay
                            v-if="hover"
                            absolute
                            color="#000000"
                            class="overlay-action-box"
                            :style="
                              $security.checkUserAccess('ViewLandingPage')
                                ? 'cursor: pointer'
                                : ''
                            "
                            opacity="0.6"
                            @click.native="
                              $security.checkUserAccess('ViewLandingPage')
                                ? viewDocument(item)
                                : null
                            "
                          >
                            <div class="action-btn align-self-end">
                              <v-tooltip bottom v-if="item.caption">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-if="
                                      $security.checkUserAccess(
                                        'ViewLandingPage'
                                      )
                                    "
                                    v-bind="attrs"
                                    v-on="on"
                                    color="white"
                                    small
                                    icon
                                    @click.stop="viewCaption(item)"
                                  >
                                    <v-icon>mdi-card-text-outline</v-icon>
                                  </v-btn>
                                </template>
                                <span>{{
                                  $t("permission.tipViewCaption")
                                }}</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-if="
                                      $security.checkUserAccess(
                                        'ViewLandingPage'
                                      )
                                    "
                                    v-bind="attrs"
                                    v-on="on"
                                    color="white"
                                    small
                                    icon
                                    @click.stop="viewDocument(item)"
                                  >
                                    <v-icon>mdi-open-in-new</v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ $t("home.tipViewDocument") }}</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-if="
                                      $security.checkUserAccess('ViewAdmin')
                                    "
                                    v-bind="attrs"
                                    v-on="on"
                                    color="white"
                                    small
                                    icon
                                    @click.stop="deleteDocument(item.id)"
                                  >
                                    <v-icon>mdi-delete</v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ $t("agenda.tipDeleteDoc") }}</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-if="
                                      $security.checkUserAccess('ViewAdmin')
                                    "
                                    class="drag-handle"
                                    small
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    style="cursor: move"
                                  >
                                    <v-icon class="white--text">
                                      mdi-drag</v-icon
                                    >
                                  </v-btn>
                                </template>
                                <span>{{
                                  $t("people.landingThumbMoveTip")
                                }}</span>
                              </v-tooltip>
                            </div>
                          </v-overlay>
                        </v-fade-transition>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-hover>
              </v-slide-item>
            </draggable>
            <v-slide-item
              v-if="$security.checkUserAccess('ViewAdmin')"
              class="widget-item"
            >
              <v-card color="grey lighten-1" class="ma-1 ml-5 rounded-xl mr-2">
                <v-card-text
                  class="full-width fill-height ma-0 pa-0 d-flex align-center height: 150px"
                  align="center"
                  justify="center"
                >
                  <div class="d-flex justify-center" style="min-width: 172px">
                    <div class="">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon
                            x-large
                            class="mr-2"
                            @click="addDocument"
                          >
                            <v-icon color="white">mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("agenda.btnAddDocument") }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-slide-item>
          </v-slide-group>

          <div
            class="d-flex justify-end full-width"
            v-if="$security.checkUserAccess('ViewAdmin')"
          >
            <div class="mr-6 mb-2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <a-btn
                    v-bind="attrs"
                    v-on="on"
                    color="primaryDark"
                    class="mr-2"
                    small
                    width="24"
                    min-width="24"
                    @click="openlandingPictureDialog"
                  >
                    <v-icon size="16" color="white">mdi-pencil</v-icon>
                  </a-btn>
                </template>
                <span>{{ $t("btnEdit") }}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="landingPicture">
                <template v-slot:activator="{ on, attrs }">
                  <a-btn
                    v-if="landingPicture && dashboardWallpaper"
                    v-bind="attrs"
                    v-on="on"
                    color="primaryDark"
                    small
                    width="24"
                    min-width="24"
                    @click="deleteLandingImage"
                  >
                    <v-icon size="16" color="white">mdi-delete</v-icon>
                  </a-btn>
                </template>
                <span>{{ $t("btnDelete") }}</span>
              </v-tooltip>
              <landing-picture-dialog
                v-if="landingPictureDialogBox"
                v-model="landingPictureDialogBox"
                @alert="onAlertMessage"
              >
              </landing-picture-dialog>
            </div>
          </div>
        </div>
      </v-img>
    </v-card>
    <add-document-dialog
      v-if="documentDialog"
      v-model="documentDialog"
      @alert="onAlertMessage"
    />
    <view-document-dialog
      v-if="viewDocumentDialog"
      v-model="viewDocumentDialog"
      :id="selectedDocument"
    />
    <view-document-caption
      v-if="viewCaptionDialog"
      v-model="viewCaptionDialog"
      :widgetData="widget"
    />
    <ConfirmDlg ref="confirmDelete" />
    <message-sheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></message-sheet>
    <prevent-navigation
      :prevent="isDirty"
      @save="saveOnLeave"
      @discard="$event.next()"
      @cancel="$event.next(false)"
    >
    </prevent-navigation>
  </div>
</template>

<script>
import ConfirmDlg from "@/components/ConfirmDialog.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import AddDocumentDialog from "./AddDocumentDialog.vue";
import ViewDocumentDialog from "./ViewDocumentDialog.vue";
import ViewDocumentCaption from "./ViewDocumentCaption.vue";
import Loader from "../Loader.vue";
import { openDocument, createUUID } from "../../utils/util";
import MessageSheet from "../MessageSheet.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
import draggable from "vuedraggable";
import PreventNavigation from "@/components/PreventNavigation.vue";
import LandingPictureDialog from "./LandingPictureDialog.vue";
import tenantConfigService from "../../api/tenantConfigService";

export default {
  name: "WidgetSlider",
  mixins: [SignalRMixin],
  components: {
    AddDocumentDialog,
    Loader,
    ViewDocumentDialog,
    ConfirmDlg,
    MessageSheet,
    draggable,
    PreventNavigation,
    ViewDocumentCaption,
    LandingPictureDialog,
  },
  props: {
    widgetHeight: Number,
  },
  data() {
    return {
      render: 0,
      slideGroupReady: false,
      displayMessage: false,
      message: "",
      messageType: "",
      documentDialog: false,
      landingPictureDialogBox: false,
      viewDocumentDialog: false,
      widget: null,
      viewCaptionDialog: false,
      selectedDocument: null,
      samplePDF: "D:/avant/anil/syncfusion/src/assets/images/samplePDF.pdf",
      isOrderChanged: false,
      displayOrders: [],
      isDirty: false,
      documentsListItems: [],
      landingPicture: "",
      loadingPicture: false,
    };
  },
  watch: {
    landingPageDocumentsList: {
      immediate: true,
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.setSortedDocumentList(newVal);
        } else {
          this.documentsListItems = [];
        }
      },
    },
    tenantList: {
      async handler(data) {
        this.loadingPicture = true;
        if (data.length) {
          const wallpaper = data.find(
            (t) => t.configname === "dashboardWallpaper"
          );
          if (wallpaper && wallpaper.dashboardWallpaper) {
            const file = await tenantConfigService.getWallpaperById(
              wallpaper.dashboardWallpaper
            );
            this.landingPicture = window.URL.createObjectURL(file);
          } else {
            this.landingPicture = require("../../assets/images/kv_pc_n1.png");
          }
        }
        this.loadingPicture = false;
      },
    },
  },
  computed: {
    ...mapState({
      landingPageDocumentsList: (state) =>
        state.document.landingPageDocumentsList,
      documentDetails: (state) => state.document.documentDetails,
      tenantList: (state) => state.tenant.tenantList,
    }),
    ...mapGetters({
      tenantSettingConfig: "tenant/tenantSettingConfig",
      tenantSettingTypes: "tenant/tenantConfigData",
    }),
    documentListItems: {
      get() {
        return this.documentsListItems;
      },
      set(value) {
        this.documentsListItems = value;
      },
    },
    dashboardWallpaper() {
      return this.tenantSettingTypes("dashboardWallpaper") || null;
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
  },
  async mounted() {
    try {
      await this.getTenantConfigList();
      await this.getLandingPageDocumentsList();
      const target = "landingpagewidgets_" + this.selectedTenant;
      const landingPictureTarget = "dashboardWallpaper_" + this.selectedTenant;
      const tanentTarget = "tenant_config_" + this.selectedTenant;
      await this.signalRInit(target);
      await this.bannerSignalRInit(landingPictureTarget);
      await this.tanentSignalRInit(tanentTarget);
      this.$emit("resize", true);
       this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.slideGroupReady = true;
        });
      });
    } catch (error) {
      console.log(error, "api error");
    }
  },
  methods: {
    ...mapActions({
      getLandingPageDocumentsList: "document/getLandingPageDocumentsList",
      deleteLandingPageDocument: "document/deleteLandingPageDocument",
      getLandingPageDocumentById: "document/getLandingPageDocumentById",
      updateTenantConfig: "tenant/updateTenantConfig",
      createTenantConfig: "tenant/createTenantConfig",
      deleteTenantConfig: "tenant/deleteTenantConfig",
      deleteDocuments: "document/deleteDocuments",
      getTenantConfigList: "tenant/getUpdatedTenantConfigList",
      updateTenentConfigValue: "tenant/updateTenentConfigValue",
      deleteLandingPageWallpaper: "tenant/deleteLandingPageWallpaper",
    }),
    isNotPDF(item) {
      return item.mimetype !== "application/pdf";
    },
    async deleteLandingImage() {
      try {
        if (
          await this.$refs.confirmDelete.open(
            this.$t("agenda.hDeleteMessage"),
            this.$t("agenda.lblDeleteMessage")
          )
        ) {
          if (this.dashboardWallpaper) {
            this.loadingPicture = true;
            const widgetWallpaper =
              this.tenantSettingConfig("dashboardWallpaper");
            if (widgetWallpaper && widgetWallpaper.id) {
              await this.deleteLandingPageWallpaper(widgetWallpaper.id);
              this.landingPicture = require("../../assets/images/kv_pc_n1.png");
              this.loadingPicture = false;
              this.$emit("resize", true);
            }
          }
        }
      } catch (error) {
        console.log(error, "api error");
      }
    },
    addDocument,
    onAlertMessage,
    showMessageSheet,
    signalRInit,
    bannerSignalRInit,
    tanentSignalRInit,
    async deleteDocument(id) {
      try {
        if (
          await this.$refs.confirmDelete.open(
            this.$t("agenda.hDeleteMessage"),
            this.$t("agenda.lblDeleteMessage")
          )
        ) {
          await this.deleteLandingPageDocument(id);
          this.showMessageSheet(
            this.$t("home.documentDeletionSuccess"),
            "success"
          );
          setTimeout(() => {
            this.render++;
          }, 200);
        }
      } catch (error) {
        console.log(error, "api error");
      }
    },
    async viewCaption(item) {
      this.widget = await this.getLandingPageDocumentById(item.id);
      this.viewCaptionDialog = true;
    },
    async viewDocument(item) {
      try {
        this.selectedDocument = item.id;
        const res = await this.getLandingPageDocumentById(item.id);
        const contentType = res.mimetype;
        this.documentType = res.mimetype;
        const blob = b64toBlob(res.doc_content, contentType);
        // var blob = new Blob([res.doc_content], { type: contentType });
        const url = window.URL || window.webkitURL;
        //this.documentFile = url.createObjectURL(blob);
        const fileUrl = url.createObjectURL(blob);
        openDocument(fileUrl, item.fileName);
      } catch (error) {
        console.log(error, "api error");
      }
    },
    openDocumentDialog() {
      this.documentDialog = true;
    },
    openlandingPictureDialog() {
      this.landingPictureDialogBox = true;
    },
    setSortedDocumentList(documentList) {
      const sortOrder = this.tenantSettingTypes("landingpagewidgetorder") || [];

      if (sortOrder.length > 0) {
        // Create a mapping of ID -> displayOrder for fast lookup
        const orderMap = new Map(
          sortOrder.map((item) => [item.id, item.displayOrder])
        );

        // Sort documents based on the saved display order
        this.documentsListItems = [...documentList].sort(
          (a, b) => (orderMap.get(a.id) ?? 999) - (orderMap.get(b.id) ?? 999)
        );
      } else {
        // If no saved order, use the default list
        this.documentsListItems = [...documentList];
      }
    },
    async onChanged(evt, items) {
      let pArr = [];
      for (let i = 0; i < items.length; i++) {
        pArr.push({
          id: items[i].id,
          displayOrder: i,
        });
      }
      if (pArr.length > 0) {
        this.isDirty = true;
        this.displayOrders = pArr;
      }
    },
    restoreOrder() {
      this.setSortedDocumentList(this.landingPageDocumentsList);
      this.isDirty = false;
    },
    async saveDisplayOrder() {
      try {
        const widgetorder = this.tenantSettingConfig("landingpagewidgetorder");

        const landingpagewidgetorder = {
          id: widgetorder?.id || createUUID(),
          tenantid: sessionStorage.getItem("tenantId"),
          configname: "landingpagewidgetorder",
          landingpagewidgetorder: this.displayOrders,
        };

        // Use update if id exists, otherwise create a new entry
        await (widgetorder?.id
          ? this.updateTenantConfig(landingpagewidgetorder)
          : this.createTenantConfig(landingpagewidgetorder));

        this.isDirty = false;
        this.$store.commit("setAlert", {
          variant: "success",
          message: this.$t("home.widgetDisplayOrderChanges"),
        });
      } catch (error) {
        console.error("Error saving widget order:", error);
      }
    },
    saveOnLeave({ next }) {
      this.saveDisplayOrder();
      next();
    },
  },
};

async function bannerSignalRInit(target) {
  try {
    this.signalConnection.on(target, async (res) => {
      if (res) {
        try {
          const file = await tenantConfigService.getWallpaperById(res);
          await this.getTenantConfigList();
          if (file) {
            this.landingPicture = window.URL.createObjectURL(file);
          }
          this.$emit("resize", true);
        } catch (error) {
          console.log(error, "API error");
        }
      }
    });
    if (
      this.signalConnection.connectionState.toLowerCase() === "disconnected"
    ) {
      this.signalConnection.start().catch();
    }
  } catch (error) {}
}
async function tanentSignalRInit(target) {
  try {
    this.signalConnection.on(target, async (res) => {
      if (res) {
        try {
          this.landingPicture = "";
          await this.getTenantConfigList();
        } catch (error) {
          console.log(error, "API error");
        }
      }
    });
    if (
      this.signalConnection.connectionState.toLowerCase() === "disconnected"
    ) {
      this.signalConnection.start().catch();
    }
  } catch (error) {}
}
async function signalRInit(target) {
  try {
    this.signalConnection.on(target, async (res) => {
      if (res) {
        try {
          await this.getLandingPageDocumentsList();
          if (res.action === "delete") {
            setTimeout(() => {
              this.render++;
            }, 200);
          }
        } catch (error) {
          console.log(error, "API error");
        }
      }
    });
    if (
      this.signalConnection.connectionState.toLowerCase() === "disconnected"
    ) {
      this.signalConnection.start().catch();
    }
  } catch (error) {}
}

const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

function onAlertMessage(message, MessageType, alertType) {
  this.showMessageSheet(message, MessageType);
  if (alertType === "wallpaper") {
    this.loadingPicture = true;
  }
   this.$nextTick(() => {
      requestAnimationFrame(() => {
          setTimeout(() => {
            this.render++;
          }, 200);
      });
    });
}

function showMessageSheet(message, messageType) {
  this.displayMessage = true;
  this.message = message;
  this.messageType = messageType;
}

function addDocument() {
  this.documentDialog = true;
}
</script>

<style scoped>
.widget-img /deep/ .v-image__image {
  background-position: center top !important;
}
.widget-item {
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.5),
    5px 4px 3px 0px rgba(0, 0, 0, 0.5) !important;
}
::v-deep .v-responsive__content {
  align-items: flex-end;
  display: flex;
}
.overlay-action-box /deep/ .v-overlay__content {
  position: unset;
}
.action-btn {
  position: absolute;
  bottom: 0;
  right: 8px;
}
::v-deep .v-slide-group__next i,
::v-deep .v-slide-group__prev i {
  font-size: 65px;
}
.border-flat {
  border-radius: 0px;
}
.draggable-row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: 0;
}

/* Main Background Image */
.mainBgImage {
  position: relative;
}

/* Overlay Above Background */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(207, 204, 206, 0.5); /* Dark Transparent Overlay */
  z-index: 1;
}

/* Ensure the Slider is Above the Overlay */
.slider-container {
  position: absolute;
  width: 100%;
  z-index: 2; /* Above overlay */
}
</style>